<template>
  <div class="p-h-border-panel">
    <div class="p-h-border-panel__inner">
      <div v-if="$slots.heading" class="p-h-border-panel__header">
        <p class="p-h-border-panel__heading">
          <slot name="heading" />
        </p>
      </div>
      <div v-if="$slots.body || specListItem" class="p-h-border-panel__body">
        <slot name="body" />
        <HSpecColumnList :list-item="specListItem" column-size="l" />
      </div>
      <div v-if="$slots.footer" :class="`p-h-container--${bodyMargin}`">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import SmallText from "@/common/components/atoms/SmallText.vue";
import HSpecColumnList from "@/general/components/pages/parts/PointHistoryList/HSpecColumnList.vue";

@Options({
  props: {
    specListItem: { type: [Array, Boolean], default: false },
    bodyMargin: { type: String, default: "m" }
  },
  components: {
    SmallText,
    HSpecColumnList
  }
})
export default class HBorderPanel extends Vue {
  specListItem!: any[] | boolean;
  bodyMargin!: string;
}
</script>

<style lang="scss" scoped>
.p-h-border-panel {
  &__inner {
    @include pc {
      width: 100%;
    }
    padding: rem(16);
    border: px(1) solid $common-gray300;
  }

  &__header {
    @include pc {
    }
    font-size: rem(14);
    font-weight: bold;
  }

  &__body {
    @include pc {
    }
    font-size: rem(14);
    margin-top: rem(4);
    line-height: 1.6;
    display: block;
  }

  &__note {
    @include pc {
    }
    font-size: $text-size__body--s;
  }
}
</style>
